export default __webpack_public_path__ + "mini-icon-ios-18@2x.png";